import { getAvailableLanguages } from '../../../@types/languages';
import DropdownBtn, { Item } from '../../ui/dropdown-btn';

export const availableLanguages: Item[] = getAvailableLanguages().map(lang => ({
  id: lang,
  label:
    lang === 'en'
      ? 'English'
      : lang === 'fr'
        ? 'French'
        : lang === 'es'
          ? 'Spanish'
          : lang === 'th'
            ? 'Thai'
            : lang === 'ko'
              ? 'Korean'
              : lang === 'es_UY'
                ? 'Uruguay (es)'
                : lang === 'es_VE'
                  ? 'Venezuela (es)'
                  : lang === 'pt_BR'
                    ? 'Brazil (pt)'
                    : lang === 'es_CO'
                      ? 'Colombia (es)'
                      : lang === 'es_GT'
                        ? 'Guatemala (es)'
                        : lang === 'es_HN'
                          ? 'Honduras (es)'
                          : lang === 'es_PA'
                            ? 'Panama (es)'
                            : lang === 'es_SV'
                              ? 'El Salvador (es)'
                              : lang === 'es_AR'
                                ? 'Argentina (es)'
                                : lang === 'es_CR'
                                  ? 'Costa Rica (es)'
                                  : lang === 'es_CL'
                                    ? 'Chile (es)'
                                    : lang === 'es_MX'
                                      ? 'Mexico (es)'
                                      : lang === 'ja'
                                        ? 'Japanese'
                                        : lang,
}));

type Props = {
  value?: Item;
  onClick: (item: Item) => void;
};

export default function LanguageDropdownComponent({ value, onClick }: Props) {
  return (
    <DropdownBtn
      none
      id="language-dropdown"
      label="Language"
      placeholder="Select language"
      value={value}
      items={availableLanguages}
      onClick={onClick as unknown as (item?: Item | null) => void}
    />
  );
}
